var _path, _path2, _path3, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgGeoPointIcon = function SvgGeoPointIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("mask", {
    id: "geo-point-icon_svg__a",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 5,
    y: 5,
    width: 22,
    height: 22
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.929 20.379C7.119 20.922 6 21.672 6 22.5c0 1.657 4.477 3 10 3s10-1.343 10-3c0-.828-1.12-1.578-2.929-2.121",
    stroke: "#fff",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16 21.5s6.5-4.248 6.5-9.159C22.5 8.839 19.59 6 16 6s-6.5 2.839-6.5 6.341C9.5 17.252 16 21.5 16 21.5Z",
    fill: "#fff",
    stroke: "#fff",
    strokeWidth: 2,
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16 15a2.5 2.5 0 1 0 0-5 2.5 2.5 0 0 0 0 5Z",
    fill: "#000",
    stroke: "#000",
    strokeWidth: 2,
    strokeLinejoin: "round"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#geo-point-icon_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4 4h24v24H4V4Z",
    fill: "#E0E0E0"
  }))));
};
export default SvgGeoPointIcon;